import { render, staticRenderFns } from "./contentLectureArticle.vue?vue&type=template&id=54c57bf3&"
import script from "./contentLectureArticle.vue?vue&type=script&lang=js&"
export * from "./contentLectureArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports